export default __webpack_public_path__ + "static/media/work2.3787a382.png";